import React, { Component } from 'react';
import { Card, CardBody } from 'reactstrap';



class ClosedTickets extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaderMap: false,
        };
    }

    render() {
        return (
            <>
                <Card>
                    <CardBody>
                        Clsed
                    </CardBody>
                </Card>
            </>
        );
    }
}

export default ClosedTickets;